import $ from 'jquery'
import Alpine from 'alpinejs'
import ImagesLoaded from './modules/ImagesLoaded'
import RelativeUrls from './modules/RelativeUrls'
import ScrollToSection from './modules/ScrollToSection'
import ViewHeigthFix from './modules/patches/ViewHeigthFix'
import HideFieldsOnFormSuccess from './modules/forms/HideFieldsOnFormSuccess'
import Validation from './modules/forms/Validation'
import Swiper from './modules/Swiper'
import FixedImages from "./modules/FixedImages";

(() => {
    window.$ = window.jQuery = $ // Load jQuery globally for OctoberCMS frontend framework

    window.Alpine = Alpine

    // Patches
    ViewHeigthFix()

    // Forms
    HideFieldsOnFormSuccess()
    Alpine.data('validation', Validation);

    // Other
    ImagesLoaded()
    RelativeUrls()
    ScrollToSection()
    Swiper()
    FixedImages()

    Alpine.start()

})()
